(function () {
  function onSummaryClick(event) {
    var summary = event.currentTarget;
    var details = summary.parentElement;
    var content = details.querySelector('.accordion__content');
    if (!content || details.hasAttribute('data-animating')) return;

    event.preventDefault();

    if (details.open) {
      closeDetails(details, content);
    } else {
      openDetails(details, content);
    }
  }

  function openDetails(details, content) {
    details.setAttribute('data-animating', 'true');
    details.open = true;

    var endHeight = content.scrollHeight;
    content.style.transitionTimingFunction = 'ease-out';
    content.style.height = '0px';

    requestAnimationFrame(function () {
      content.style.height = endHeight + 'px';
    });

    content.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', handler);
      content.style.height = 'auto';
      details.removeAttribute('data-animating');
    });
  }

  function closeDetails(details, content) {
    details.setAttribute('data-animating', 'true');

    var startHeight = content.scrollHeight;
    content.style.transitionTimingFunction = 'ease-in';
    content.style.height = startHeight + 'px';

    // Force a reflow so the browser registers the starting height
    // before we change it, otherwise it can't transition from it.
    // eslint-disable-next-line no-unused-expressions
    content.offsetHeight;

    requestAnimationFrame(function () {
      content.style.height = '0px';
    });

    content.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', handler);
      details.open = false;
      content.style.height = '';
      content.style.transitionTimingFunction = '';
      details.removeAttribute('data-animating');
    });
  }

  function bindAccordions(root) {
    (root || document).querySelectorAll('.accordion > details > summary').forEach(function (summary) {
      if (summary.hasAttribute('data-accordion-bound')) return;
      summary.setAttribute('data-accordion-bound', 'true');
      summary.addEventListener('click', onSummaryClick);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAccordions(document);
  });

  // Re-scan if the theme editor re-renders a section (e.g. while
  // customizing), so newly injected accordions still animate.
  document.addEventListener('shopify:section:load', function (event) {
    bindAccordions(event.target);
  });
})();
